import React from 'react'
import { motion } from 'framer-motion'
import clsx from 'clsx'

export const Card = ({ 
  children, 
  className, 
  variant = 'neumorphic',
  hover = false,
  ...props 
}) => {
  const baseClasses = 'rounded-2xl p-6'
  
  const variants = {
    neumorphic: 'bg-white border border-gray-300 shadow-sm',
    glass: 'bg-white border border-gray-300 shadow-sm',
    gradient: 'bg-white border border-gray-300 shadow-sm'
  }
  
  const hoverAnimation = hover ? {
    whileHover: { 
      y: -4,
      transition: { duration: 0.2 }
    },
    whileTap: { 
      y: 0,
      transition: { duration: 0.1 }
    }
  } : {}

  return (
    <motion.div
      className={clsx(baseClasses, variants[variant], className)}
      initial={{ opacity: 0, y: 20 }}
      animate={{ opacity: 1, y: 0 }}
      transition={{ duration: 0.5 }}
      {...hoverAnimation}
      {...props}
    >
      {children}
    </motion.div>
  )
}

export const CardHeader = ({ children, className }) => (
  <div className={clsx('mb-4', className)}>
    {children}
  </div>
)

export const CardTitle = ({ children, className }) => (
  <h3 className={clsx('text-xl font-semibold text-brand-darkText', className)}>
    {children}
  </h3>
)

export const CardContent = ({ children, className }) => (
  <div className={clsx('text-brand-darkText', className)}>
    {children}
  </div>
)